const Updating = (state = true, action) => {

    switch (action.type) {

        case "UPDATE":

            return !state

        default:

            return state

    }

}

export default Updating